export const getHighlightBgColor = annoTagType => {
    switch(annoTagType){
      case 'quotes':
        return 'pinkHighlight';
      case 'vocabs':
        return 'blueHighlight';
      default: 
        return 'yellowHighlight'
    }
  }